import React from "react";
import Typography from "@material-ui/core/Typography";
const Vendor = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Vendor
      </Typography>
      <Typography paragraph variant="h5">
        Manage vendor master data for good quality service
      </Typography>
      <Typography paragraph variant="body1">
        Vendor is one of the features under the Procurement module to manage
        vendor master data which is ready to supply products or materials to the
        company. It contains any information regarding the contact person,
        personal or company background, and address details of each vendor.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Vendor list. It
        is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor ID</b>
        <br />
        Indicates the ID of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Name</b>
        <br />
        Indicates the full name of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Phone Number</b>
        <br />
        Indicates the contact phone number of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>City</b>
        <br />
        Indicates the city location of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 4 buttons that appear on each row of Vendor data with
        specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Whatsapp Chat Vendor</b>
        <br />
        This button only appears if the Vendor has a valid phone number. It is
        used to automatically redirect to WhatsApp API to send a conversation to
        the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Vendor</b>
        <br />
        This button is used to edit the Vendor data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Detail</b>
        <br />
        This button is used to navigate to the Vendor detail which contains some
        tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Vendor data.
          </li>
          <li>
            <b>Addresses</b> : This tab is to display the main address and
            additional addresses of Vendor.
          </li>
          <li>
            <b>Contacts</b> : This tab is to display the main contact and
            additional contacts of Vendor.
          </li>
          <li>
            <b>Bank Accounts</b> : This tab is to display any Bank Accounts
            related to the Vendor.
          </li>
          <li>
            <b>Quotations</b> : This tab is to display any Quotations related to
            the Vendor.
          </li>
          <li>
            <b>Purchase Orders</b> : This tab is to display any Purchase Orders
            related to the Vendor.
          </li>
          <li>
            <b>A/P Invoices</b> : This tab is to display any A/P Invoices
            related to the Vendor.
          </li>
          <li>
            <b>A/P Payments</b> : This tab is to display any A/P Payments
            related to the Vendor.
          </li>
          <li>
            <b>Pending GRs</b> : This tab is to display any Pending GRs related
            to the Vendor.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Vendor.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Vendor.
          </li>
        </ul>
        When opening the Vendor detail, there will be 1 button appearing on the
        top section. The button is 'Edit Vendor' which is used to edit the
        Vendor data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Vendor</b>
        <br />
        This button is used to delete the Vendor data. The Vendor data is
        undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default Vendor;
